import { findIndex } from 'lodash';
import { ExecutionResult } from 'react-apollo';
import { DataProxy } from 'apollo-cache';
import { DocumentNode } from 'graphql';
import produce, { Draft } from 'immer';

import { Content, QueryGetFeedArgs } from 'api';
import { postedToGroups } from 'apollo/reducers';

type ReducerArgs = (results: Content[], data: Content, contentId: Content['content_id']) => void;

interface IReducer {
  name: keyof IReducers;
  cache: DataProxy;
  result: ExecutionResult;
  query: DocumentNode;
  variables: QueryGetFeedArgs;
  contentId?: Content['content_id'];
}

interface IReducers {
  addPost: ReducerArgs;
  removePost: ReducerArgs;
}

const reducers: IReducers = {
  addPost: produce((draft: Draft<Content[]>, data) => {
    draft.unshift(data);
    return draft;
  }),
  removePost: produce((draft: Draft<Content[]>, data, contentId) => {
    const index = findIndex(draft, { content_id: contentId });
    draft.splice(index, 1);
    return draft;
  }),
};

export default (options: IReducer) => {
  const { name, cache, result, query, variables, contentId } = options;
  const { getFeed } = cache.readQuery({ query, variables });

  if (!getFeed) {
    return;
  }

  const mutations = Object.keys(result.data);

  mutations.forEach(mutation => {
    const updated = reducers[name](getFeed.results, result.data[mutation], contentId);
    cache.writeQuery({
      query,
      variables,
      data: { getFeed: { ...getFeed, results: updated } },
    });
  });

  if (name === 'addPost') {
    postedToGroups({ cache, result });
  }
};
